import { useState, useEffect } from 'react';
import './Events.css';
import eventsPic1 from '../events/image (1).webp'
import eventsPic2 from '../events/image (2).webp'
import eventsPic4 from '../events/image (4).webp'
import eventsPic5 from '../events/image (5).webp'
import eventsPic6 from '../events/image (6).webp'
import eventsPic7 from '../events/image (7).webp'
import eventsPic8 from '../events/image (8).webp'
import eventsPic9 from '../events/image (9).webp'
import eventsPic10 from '../events/image (10).webp'
import eventsPic11 from '../events/image (11).webp'
import eventsPic17 from '../events/image (17).webp'
import eventsPic20 from '../events/image (20).webp'
import eventsPic22 from '../events/image (22).webp'
import eventsPic23 from '../events/image (23).webp'
import eventsPic24 from '../events/image (24).webp'
import eventsPic25 from '../events/image (25).webp'
import eventsPic26 from '../events/image (26).webp'
import eventsPic27 from '../events/image (27).webp'
import eventsPic28 from '../events/image (30).webp'
import eventsPic29 from '../events/image (31).webp'
import eventsPic30 from '../events/image (32).webp'
import independent1 from '../events/15aug (1).webp'
import independent2 from '../events/15aug (2).webp'
import independent3 from '../events/15aug (3).webp'
import independent4 from '../events/15aug (4).webp'
import independent5 from '../events/15aug (5).webp'
import independent6 from '../events/15aug (6).webp'
import independent7 from '../events/15aug (7).webp'
import independent8 from '../events/15aug (8).webp'
import independent9 from '../events/15aug (9).webp'

const EventsPage = () => {
   const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [allImages, setAllImages] = useState([]);

  // Gallery images for Session 2024-25
  const galleryImages = [
    { id: 4, src: eventsPic4, alt: 'Events 4' }, 
    { id: 8, src: eventsPic8, alt: 'Events 8' },
    { id: 9, src: eventsPic9, alt: 'Events 9' },
    { id: 6, src: eventsPic6, alt: 'Events 6' },
    { id: 11, src: eventsPic11, alt: 'Events 11' },
    { id: 7, src: eventsPic7, alt: 'Events 7' },
    { id: 3, src: independent1, alt: 'independent 1' },  
    { id: 14, src: independent2, alt: 'independent 2' },
    { id: 21, src: independent3, alt: 'independent 3' },
    { id: 18, src: independent4, alt: 'independent 4' },
    { id: 12, src: independent5, alt: 'independent 5' },
    { id: 13, src: independent6, alt: 'independent 6' },
    { id: 16, src: independent8, alt: 'independent 8' },
    { id: 19, src: independent9, alt: 'independent 9' },
    { id: 20, src: eventsPic20, alt: 'Events 20' },
    { id: 17, src: eventsPic17, alt: 'Events 17' },
    { id: 22, src: eventsPic22, alt: 'Events 22' },
    { id: 23, src: eventsPic23, alt: 'Events 23' },
    { id: 24, src: eventsPic24, alt: 'Events 24' },
    { id: 27, src: eventsPic27, alt: 'Events 27' },
    { id: 25, src: eventsPic25, alt: 'Events 25' },
    { id: 26, src: eventsPic26, alt: 'Events 26' },
    { id: 15, src: independent7, alt: 'independent 7' },
    { id: 10, src: eventsPic10, alt: 'Events 10' },
    { id: 1, src: eventsPic1, alt: 'Events 1' },
    { id: 5, src: eventsPic5, alt: 'Events 5' },
    { id: 2, src: eventsPic2, alt: 'Events 2' },
    { id: 28, src: eventsPic28, alt: 'Events 28' },
    { id: 29, src: eventsPic29, alt: 'Events 29' },
    { id: 30, src: eventsPic30, alt: 'Events 30' },
  ];

  useEffect(() => {
    setAllImages(galleryImages);
  }, []);

  const handleImageClick = (imageSrc) => {
    const imageIndex = galleryImages.findIndex(image => image.src === imageSrc);
    setCurrentImageIndex(imageIndex);
  };

  const closeModal = () => {
    setCurrentImageIndex(null);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (currentImageIndex === null) return;      
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
      if (e.key === 'Escape') closeModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentImageIndex]);

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>EVENTS</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Events</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="events-container">
        {/* Title Section */}
        <div className="events-title-section">
          <h2>EVENTS</h2>
          <div className="events-title-underline"></div>
        </div>

        {/* Session Gallery */}
        <section className="events-gallery-section">
          
          <div className="events-gallery">
            {galleryImages.map((image, index) => (
              <div 
                key={image.id} 
                className={`events-gallery-item ${index % 2 === 0 ? 'events-left' : 'events-right'}`}
                onClick={() => handleImageClick(image.src)}
              >
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {currentImageIndex !== null && (
        <div className="events-modal show" onClick={(e) => {
          if (e.target.classList.contains('events-modal')) {
            closeModal();
          }
        }}>
          <div className="events-modal-wrapper">
            <button className="events-modal-close" onClick={closeModal}>&times;</button>
            <button className="events-modal-btn events-modal-prev" onClick={prevImage}>❮</button>
            <img 
              className="events-modal-image" 
              src={galleryImages[currentImageIndex].src} 
              alt={galleryImages[currentImageIndex].alt}
            />
            <button className="events-modal-btn events-modal-next" onClick={nextImage}>❯</button>
          </div>
        </div>
      )}
    </>
  );
};

export default EventsPage;